import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import  api  from "../services/api";

export const RESTAURANT_MANAGEMENT_QUERY_KEYS = {
  RESTAURANTS: ["restaurant-management", "restaurants"],
};

export const useRestaurantsForManagement = (enabled = true) =>
  useQuery({
    queryKey: RESTAURANT_MANAGEMENT_QUERY_KEYS.RESTAURANTS,
    queryFn: async () => {
      const response = await api.get("/restaurant-management/restaurants");
      return response.data?.data || [];
    },
    enabled,
    
  });

export const useUpdateRestaurantOpenStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ restaurantId, isOpen }) => {
      const response = await api.patch(
        `/restaurant-management/restaurants/${restaurantId}/status`,
        { isOpen }
      );
      return response.data?.data;
    },
    onMutate: async ({ restaurantId, isOpen }) => {
      await queryClient.cancelQueries({
        queryKey: RESTAURANT_MANAGEMENT_QUERY_KEYS.RESTAURANTS,
      });

      const previousRestaurants = queryClient.getQueryData(
        RESTAURANT_MANAGEMENT_QUERY_KEYS.RESTAURANTS
      );

      queryClient.setQueryData(
        RESTAURANT_MANAGEMENT_QUERY_KEYS.RESTAURANTS,
        (restaurants = []) =>
          restaurants.map((restaurant) =>
            restaurant._id === restaurantId
              ? {
                  ...restaurant,
                  isOpen,
                  closedToday: !isOpen,
                }
              : restaurant
          )
      );

      return { previousRestaurants };
    },
    onError: (_error, _variables, context) => {
      if (context?.previousRestaurants) {
        queryClient.setQueryData(
          RESTAURANT_MANAGEMENT_QUERY_KEYS.RESTAURANTS,
          context.previousRestaurants
        );
      }
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: RESTAURANT_MANAGEMENT_QUERY_KEYS.RESTAURANTS,
      });
    },
  });
};
